<template>
  <div class="wrapper">
    <mobile-header @reserve="openReserveDialog" />
    <login-box @login="openReserveDialog" />
    <banner :video="videoSrc" :reserveCount="reserveCount" @reserve="openReserveDialog" />
    <div class="main">
      <news-module :newsPicList="newsPicList" />
      <reservation-module :giftData="reservationGiftsData" @reserve="openReserveDialog" @viewRule="openRuleDialog" v-if="stage == 0" />
      <download-module :giftData="downloadGiftsData" v-else-if="stage == 1" />
      <invitation-module :giftData="invitationGiftsData" :giftLog="invitationGiftsLog" @viewRule="openRuleDialog" @afterGetReward="getGiftData" @success="getGiftData" />
      <character-module :characterData="characterList" />
      <feature-module :featureData="featureList" />
      <social-module />
    </div>
    <mobile-footer />
    <reserve-dialog @success="getGiftData" :visible.sync="reserveDialogVisible" />
    <rule-dialog :visible.sync="ruleDialogVisible" :rule="activityRule" />
    <!-- <login-dialog @success="getGiftData" /> -->
    <tips-dialog />
    <wechat-tips-wrapper v-if="wechatTipsVisible" />
  </div>
</template>

<script>
import MobileHeader from '@/views/mobile/components/header/Index.vue'
import LoginBox from './components/loginBox/Index.vue'
import Banner from './components/banner/Index.vue'
import NewsModule from './components/news/Index.vue'
import ReservationModule from './components/reservation/Index.vue'
import DownloadModule from './components/download/Index.vue'
import InvitationModule from './components/invitation/Index.vue'
import CharacterModule from './components/character/Index.vue'
import FeatureModule from './components/feature/Index.vue'
import SocialModule from './components/social/Index.vue'
import MobileFooter from '@/views/mobile/components/footer/Index.vue'
import TipsDialog from '@/views/mobile/components/tipsDialog/Index.vue'
import ReserveDialog from '@/views/mobile/components/reserveDialog/Index.vue'
import RuleDialog from '@/views/mobile/components/ruleDialog/Index.vue'
// import LoginDialog from '@/views/mobile/components/loginDialog/Index.vue'
import WechatTipsWrapper from '@/views/mobile/components/wechatTipsWrapper/Index.vue'

import homeMixins from '@/mixins/home/homeMixins.js'

export default {
  name: 'MobileHome',
  mixins: [homeMixins],
  components: {
    MobileHeader,
    LoginBox,
    Banner,
    NewsModule,
    ReservationModule,
    DownloadModule,
    InvitationModule,
    CharacterModule,
    FeatureModule,
    SocialModule,
    MobileFooter,
    TipsDialog,
    ReserveDialog,
    RuleDialog,
    // LoginDialog,
    WechatTipsWrapper,
  },
  computed: {
    wechatTipsVisible() {
      return this.$store.getters.wechatTipsVisible
    },
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 1009.6vw;
  background: url('~@/assets/img/mobile/body_bg.jpg') no-repeat;
  background-size: 100%;
  background-position: center;
}
</style>

<style lang="scss">
.wrapper {
  width: 100%;
}

.module {
  position: relative;
  padding-top: 9.466666vw;

  &__title {
    width: 100%;
    height: 23.2vw;
    background: url('~@/assets/img/mobile/title.png') no-repeat;
    background-size: 100% 163.2vw;
  }
}
</style>